export const Global = {
    info: 'infoLWS',
    infoName: "LWS",
    infoTime: "infoExpirationLWS",
    valuePlantStorage: "plant",
    path: null,
};